// extracted by mini-css-extract-plugin
export default {"vehicle-display":"vehicle-image__vehicle-display___1Oe35","image":"vehicle-image__image___17TcO"};